import { http } from '@noor/api';
import { env } from '@noor/config';
import { restaurantCategorySchema, type RestaurantCategory } from '../model/schema';

/**
 * Restaurant category admin API on the Eats host (`VITE_EATS_API_URL`, paths
 * carry `/api/v1`). Only the category-name read is wired — the restaurant
 * review modal resolves the branch's category through it.
 */

const eatsBase = { baseURL: env.VITE_EATS_API_URL };

/**
 * Unwrap the detail envelope (`{data:{restaurant_category}}` per
 * `openapi-eats-admin.json`, flat kept as fallback). Pure, so the envelope
 * shapes stay covered without mocking `http`.
 */
export function normalizeRestaurantCategoryDetail(
  raw: unknown,
): RestaurantCategory | undefined {
  const root = (raw ?? {}) as Record<string, unknown>;
  const data = (root.data ?? {}) as Record<string, unknown>;
  const candidate = data.restaurant_category ?? root.restaurant_category ?? root;
  const parsed = restaurantCategorySchema.safeParse(candidate);
  if (!parsed.success) return undefined;
  if (parsed.data.id == null && parsed.data.name == null) return undefined;
  return parsed.data;
}

export const restaurantCategoryApi = {
  /** Category detail by id — `undefined` when the row carries no identity. */
  async detail(categoryId: string): Promise<RestaurantCategory | undefined> {
    const raw = await http.get<unknown>(
      `/api/v1/admin/restaurant-categories/${categoryId}`,
      eatsBase,
    );
    return normalizeRestaurantCategoryDetail(raw);
  },
};
